import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let LatePickUpCheckController = {

    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/late-pick-up-check/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    list: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/late-pick-up-check/list-student-check`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    }
}

export default LatePickUpCheckController